import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {Divider, Space, Tabs} from "antd";
import MatchTable from "../MatchTable";
import {setKey} from "../../util/util";
import Icon from "../Icon";
import HeroTable from "../HeroTable";
import Max from "../Max";
import HeroLadders from "../HeroLadders";

export default () => {

    const {t} = useTranslation()
    const params = useParams()
    const heroId = params.id
    const [data,setData] = useState(null)

    useEffect(() => {
        axios.get(`hero/info/${heroId}`).then(res => {
            setData(res)
        })
    }, [params.id])


    const tabs = [

        {
            label: t('matches'),
            key: "matches",
            children: <MatchTable heroId={heroId} style={{  width: '900px', }} columns={['region', 'mode', 'duration', 'kda', 'result', "score", 'endTime']} update={(pageInfo, setData) => {
                axios.get(`game/list`,{
                    params: {
                        current: pageInfo.current,
                        pageSize: 10,
                        heroId,
                    }
                }).then(data => {
                    setKey(data.records, 'id')
                    pageInfo.total = data.total
                    pageInfo.pageSize = 10
                    setData(data.records)
                })
            }}/>
        },
        {
            label: t('players'),
            key: "players",
            children: <HeroLadders heroId={heroId}/>
        }

    ]


    return <Space direction={'vertical'} size={20}>
        <Space><Icon type={'hero'} name={heroId} size={36} /><span style={{fontSize: '30px'}}>{t(`heroName.${heroId}`)}</span></Space>
        {
            data && <Space style={{fontSize: "20px"}} size={60}>
                <div style={{width: "200px"}} >{`${t('heroListTitle.pickPercentage')}: ${data.pickPercentage}%`}</div>
                <div style={{width: "200px"}} >{`${t('heroListTitle.winPercentage')}: ${data.winPercentage}%`}</div>
                <div style={{width: "200px"}} >{`${t('heroListTitle.banPercentage')}: ${data.banPercentage}%`}</div>
            </Space> || null
        }
        <Tabs
            defaultActiveKey="1"
            centered
            items={tabs}
        />

    </Space>
}
